(function () {
    "use strict";

    angular
        .module("atheer.public")
        .controller("PublicController", PublicController);

    /* @ngInject */
    function PublicController($scope, $window, $state, $sce, $location) {
        var vm = this;
        vm.ngxUrlTrusted = null;
        vm.isIFrameDataLoaded = false;

        function setNgxPageUrl() {
            var ngxUrl = null;
            var hostUrl =
                location.hostname === "localhost"
                    ? "https://" + location.hostname + ":4200"
                    : location.origin;
            var path = $location.path();

            if ($state.current.name == "public.home") {
                ngxUrl = hostUrl + "/ngx/home";
            } else if ($state.current.name == "public.topics") {
                ngxUrl = hostUrl + "/ngx/topics";
            } else if ($state.current.name == "public.topics-detail") {
                var id = path.split("/").pop();
                ngxUrl = hostUrl + "/ngx/topics/" + id;
            } else if ($state.current.name == "public.content-detail") {
                var id = path.split("/").pop();
                ngxUrl = hostUrl + "/ngx/contents/" + id;
            } else if ($state.current.name == "public.unified-search") {
                var id = path.split("/").pop();
                ngxUrl = hostUrl + "/ngx/home/search?" + id;
            } else if ($state.current.name == 'public.job-execute') {
                var id = path.split('/').pop();
                ngxUrl = hostUrl + '/ngx/job/execute/' + id;
            } else if ($state.current.name == 'public.job-detail-by-job-number') {
                var id = path.split('/').pop();
                ngxUrl = hostUrl + '/ngx/jobs/jobNumber/' + id;
            } else if ($state.current.name == 'public.job-detail') {
                var id = path.split('/').pop();
                ngxUrl = hostUrl + '/ngx/jobs/' + id;
            }
            vm.ngxUrlTrusted = $sce.trustAsResourceUrl(ngxUrl);
        }

        function handleNgxEvent(event) {
            var hostUrl =
                location.hostname === "localhost"
                    ? "https://" + location.hostname + ":4200"
                    : location.origin;
            if (event.origin !== hostUrl) return;
            if (event.data.ngxLocationChanged) {
                var ngState = event.data.ngxLocationChanged.ngState;
                var id = event.data.ngxLocationChanged.id;
                var queryParams = event.data.ngxLocationChanged.queryParams;
                id = id ? id : queryParams;
                vm.isIFrameDataLoaded = true;
                scopeApply();

                if (id == null && queryParams == null) {
                    $state.transitionTo(ngState, null, {
                        location: true,
                        inherit: true,
                        relative: $state.$current,
                        notify: false
                    });
                } else {
                    $state.transitionTo(
                        ngState,
                        {
                            id: id
                        },
                        {
                            location: true,
                            inherit: true,
                            relative: $state.$current,
                            notify: false
                        }
                    );
                }
            }
        }

        var scopeApply = function (fn) {
            var phase = $scope.$root.$$phase;
            if (phase !== "$apply" && phase !== "$digest") {
                return $scope.$apply(fn);
            }
        };

        $window.addEventListener("message", handleNgxEvent, false);

        // Unregister
        $scope.$on("$destroy", function () {
            window.removeEventListener("message", handleNgxEvent, false);
        });

        setNgxPageUrl();
    }
})();
